import { graphqlRequest } from "../graphqlClient";
import type {
  ScenarioShareUserConnection,
  ScenarioShareUserViewFilterInput,
} from "../models/scenarioShareUser";

interface ScenarioShareUserListResponse {
  scenarioShareUsers: {
    scenarioShareUserViewList: ScenarioShareUserConnection;
  };
}

/**
 * Fetches the candidate users for the Submit Scenario reviewer picklist from the
 * scenarioShareUsers GraphQL query (backed by vw_ScenarioShareUsers). Returns only the
 * minimal picklist fields (userId, name, roleName). An optional search string filters
 * on name / role name via the summary filter.
 */
export async function getScenarioShareUsersGraphql(
  search?: string,
  first = 200,
): Promise<ScenarioShareUserConnection> {
  const filter: ScenarioShareUserViewFilterInput | undefined = search
    ? { summary: search }
    : undefined;

  const query = `
    query ScenarioShareUserViewList($filter: ScenarioShareUserViewFilterInput, $first: Int) {
      scenarioShareUsers {
        scenarioShareUserViewList(filter: $filter, first: $first) {
          edges {
            cursor
            node {
              userId
              name
              roleName
            }
          }
          pageInfo {
            hasNextPage
            hasPreviousPage
            startCursor
            endCursor
          }
        }
      }
    }
  `;

  const data = await graphqlRequest<ScenarioShareUserListResponse>(query, {
    filter,
    first,
  });
  return data.scenarioShareUsers.scenarioShareUserViewList;
}
